import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'normalize.css';
import './index.css';
import App from './App';
import { CartProvider } from './context/CartContext';
import ScrollToTop from './utils/scrollTop';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <CartProvider>
    <BrowserRouter>
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </CartProvider>
);
